export default function(amount) {
    return amount < 10 ? `0${amount}` : `${amount}`;
}
